import { render } from "./ManageDetails.vue?vue&type=template&id=7d6c84d2&scoped=true"
import script from "./ManageDetails.vue?vue&type=script&lang=js"
export * from "./ManageDetails.vue?vue&type=script&lang=js"

import "./ManageDetails.vue?vue&type=style&index=0&id=7d6c84d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6c84d2"]])

export default __exports__